import gql from 'graphql-tag';
import { reportRecordGQLFields, } from './reportRecord.fields.js';
export const getActivityLogsGQLQuery = (fields) => gql `
  query ActivityLogs($query: String!) {
    activityLogs(query: $query) {
      ${reportRecordGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=activityLogs.gql.js.map